import React, { useCallback, useContext, useEffect, useMemo, useState, } from "react";
import uuid from "uuid";
export const ModalStackContext = React.createContext(undefined);
export const ModalProvider = ({ children, }) => {
    const [modalStack, setModalStack] = useState([]);
    const add = useCallback((id) => setModalStack((current) => [...current, id]), []);
    const remove = useCallback((id) => setModalStack((current) => current.filter((existingModalId) => existingModalId !== id)), []);
    const topMostModal = useMemo(() => modalStack[modalStack.length - 1], [modalStack]);
    const value = useMemo(() => ({ add, remove, topMostModal }), [add, remove, topMostModal]);
    return (React.createElement(ModalStackContext.Provider, { value: value }, children));
};
export const useModalManager = (isOpen, id) => {
    const context = useContext(ModalStackContext);
    if (!context) {
        throw new Error("sc-web-ui: useModalManager hook was called outside of ModalProvider context");
    }
    const [internalId] = useState(id || uuid.v4());
    const isTopModal = useMemo(() => context.topMostModal === internalId, [context, internalId]);
    useEffect(() => {
        if (isOpen) {
            context.add(internalId);
        }
        return () => {
            context.remove(internalId);
        };
    }, [isOpen, internalId, context]);
    return { isTopModal };
};
